import Api from "./ApiHomePage/APi"
import Pricing from "./Pricing/Pricing"
export default function Platform(){
    return (
        <main>
        <Api />
        <Pricing/>
        </main>
    )
}